import BaseEventGroups from 'cio/utils/base-events';
export default BaseEventGroups;
